import { Modal } from 'antd'
import classNames from 'classnames'
import { MouseEvent, ReactNode } from 'react'

import cn from './ModalWithButtons.module.scss'

type ModalWithButtonsPropsType = {
  children: ReactNode
  title: string
  open: boolean
  onOk: (e: MouseEvent<HTMLButtonElement>) => void
  onCancel: () => void
  okText?: string
  confirmLoading?: boolean
  isOrganisationSelected?: boolean
}

function ModalWithButtons(props: ModalWithButtonsPropsType) {
  const {
    children,
    okText = 'Сохранить',
    title,
    open,
    confirmLoading,
    isOrganisationSelected = false,
    onOk,
    onCancel,
  } = props

  return (
    <div className={cn.modalContainer} onClick={(e) => e.stopPropagation()}>
      <Modal
        centered
        destroyOnHidden
        closable={false}
        title={title}
        open={open}
        onOk={(e) => {
          onOk(e)
          e.stopPropagation()
        }}
        confirmLoading={confirmLoading}
        onCancel={(e) => {
          onCancel()
          e.stopPropagation()
        }}
        okText={okText}
        cancelText="Отменить"
        className={classNames(
          cn.modal,
          isOrganisationSelected && cn.modalSelected
        )}
      >
        <div className={cn.modalContent}>{children}</div>
      </Modal>
    </div>
  )
}

export default ModalWithButtons
